(function (global) {
  'use strict';
  if (global.GiftsboxlyMultibuy) return;
  let cartQuantity;
  function readQuantity(root) {
    const value = root.querySelector('[data-giftsboxly-multibuy-cart]')?.getAttribute('data-giftsboxly-multibuy-cart');
    if (value == null || !/^\d+$/.test(value)) return null;
    const quantity = Number(value);
    return Number.isSafeInteger(quantity) ? quantity : null;
  }
  function percentageLeft(element, quantity, fallback, subscription = element.subscriptionWidget?.isSubSelected) {
    if (element.dataset.multibuyEligible == null) return fallback;
    if (element.dataset.multibuyEligible !== 'true' || subscription) return 1;
    const count = (cartQuantity ?? readQuantity(document) ?? 0) + Number(quantity);
    return count >= 4 ? .8 : count >= 3 ? .85 : count >= 2 ? .9 : 1;
  }
  function unitPrice(price, left) {
    const percent = Math.round((1 - left) * 100);
    return price - Number(BigInt(price) * BigInt(percent) / 100n);
  }
  function refresh(quantity) {
    if (quantity == null || quantity === cartQuantity) return;
    cartQuantity = quantity;
    document.querySelectorAll('quantity-breaks').forEach(root => root.refreshMultibuyPrices?.());
    document.querySelectorAll('bundle-deals[data-multibuy="true"]').forEach(root => root.updateTotalPrice?.());
    document.querySelectorAll('[data-multibuy-note]').forEach(note => {
      note.textContent = 'Mix and match eligible products: 2 = 10% off, 3 = 15% off, 4+ = 20% off. '
        + (quantity ? 'Prices include ' + quantity + ' eligible item(s) already in your cart. ' : '')
        + 'Services and gift cards are excluded.';
    });
  }
  global.GiftsboxlyMultibuy = Object.freeze({percentageLeft, unitPrice});
  function init() {
    refresh(readQuantity(document));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const html = event?.cartData?.sections?.['cart-drawer'];
      // Read one numeric value from the Shopify section; never insert or execute its HTML.
      const quantity = typeof html === 'string' ? readQuantity(new DOMParser().parseFromString(html, 'text/html')) : null;
      if (quantity != null) refresh(quantity);
      else queueMicrotask(() => refresh(readQuantity(document)));
    });
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})(window);
